import { createContext, useContext } from "react";

import { type AnalyticsInstance } from "analytics";

import { type IBtAnalyticsPlugin } from "./plugins/IBtAnalyticsPlugin";

export interface IAnalyticsHandle {
  instance: AnalyticsInstance | null;
  /**
   * Every registered plugin, in the order the host declared them. `null` only
   * when no `AnalyticsProvider` mounted an ancestor (e.g. an isolated test
   * that skipped setup). Tests that need to drive a specific plugin can
   * inline-construct one and pass `plugins: [it]` to a manual
   * `AnalyticsHandleContext.Provider`.
   */
  plugins: readonly IBtAnalyticsPlugin[] | null;
}

export const AnalyticsHandleContext = createContext<IAnalyticsHandle>({
  instance: null,
  plugins: null,
});

export function useAnalyticsHandle(): IAnalyticsHandle {
  return useContext(AnalyticsHandleContext);
}
